import { api as affiliateApi } from './auto-generated/affiliate'

affiliateApi.enhanceEndpoints({
  endpoints: {},
})

export { affiliateApi }
